import React from "react";
import CheckIcon from "app/components/Icons/CheckIcon";
import CustomTooltip from "app/components/Tooltip";

import {
  NotificationRowProps,
  NotificationMethodEnum,
} from "app/containers/Features/containers/TeamSettings/container/Notification/type";

const NotificationFormatType = (type: string) => {
  return type
    .replace(/([^ ])([A-Z])/g, "$1 $2")
    .replace(/^./, (str) => str.toUpperCase());
};

const NotificationRow: React.FC<NotificationRowProps> = ({
  row,
  gridTemplateColumns,
  onToggle,
}) => {
  return (
    <div
      className="grid h-[52px] items-center border-b border-x border-gray-100 text-sm text-secondary last:border-b-0"
      style={{ gridTemplateColumns }}
    >
      <div className="flex h-full items-center px-6 truncate text-sm font-normal leading-[21px] text-[#333E4D]">
        {NotificationFormatType(row.type)}
      </div>

      <div
        className="flex h-full items-center px-6 cursor-pointer hover:bg-gray-400 transition-colors "
        onClick={() => onToggle(row._id, NotificationMethodEnum.Web)}
      >
        <CustomTooltip
          text={row.isWebEnabled ? "Click to unselect" : "Click to select"}
          position="bottom"
        >
          <div className="flex items-center justify-center w-6 h-6">
            <CheckIcon
              size={24}
              color={row.isWebEnabled ? "#5A8DF1" : "#BDC0C3"}
            />
          </div>
        </CustomTooltip>
      </div>

      <div
        className="flex h-full items-center px-6 cursor-pointer hover:bg-gray-400 transition-colors"
        onClick={() => onToggle(row._id, NotificationMethodEnum.Email)}
      >
        <CustomTooltip
          text={row.isEmailEnabled ? "Click to unselect" : "Click to select"}
          position="bottom"
        >
          <div className="flex items-center justify-center w-6 h-6">
            <CheckIcon
              size={24}
              color={row.isEmailEnabled ? "#5A8DF1" : "#BDC0C3"}
            />
          </div>
        </CustomTooltip>
      </div>
    </div>
  );
};

export default NotificationRow;
